import { REGION, RegionEnum } from '../constants';

export const getLocaleFormat = () => {
  switch (REGION) {
    case RegionEnum.Eu:
      return 'en-SE';
    case RegionEnum.Ca:
      return 'en-CA';
    case RegionEnum.Us:
      return 'en-US';
    case RegionEnum.Gb:
      return 'en-GB';
  }
};
